module.exports = __webpack_public_path__ + "img/2.66d2ab05.png";